import service from '@/untils/request'
// 登录
export function sysUser(data) {
    return service({
        url: '/sign_in',
        method: 'POST',
        data
    })
}

// 登录信息
export function userInfo(data) {
    return service({
        url: '/user_info',
        method: 'GET',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/login.js